import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.testimonial-hero__splide' ).length ) {
        $( '.testimonial-hero__splide' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'fade',
            rewind: true,
            perPage: 1,
            perMove: 1,
            pagination: false,
            arrows: true,
          } );

          splide.mount( {} );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'testimonial-hero', COMPONENT );
} )( app );
